function cardProductResolveImgUrl(value) {
  if (value == null || String(value).trim() === '') return '';
  var v = String(value).trim();
  if (v.indexOf('https://') === 0 || v.indexOf('http://') === 0) return v;
  if (v.indexOf('//') === 0) return window.location.protocol + v;
  var base = window._shopUrl || window.location.origin;
  if (v.indexOf('/cdn/') === 0) return base + v;
  return base + '/cdn/shop/' + v.replace(/^\/+/, '');
}

function updateImages(e) {
  var cardRoot =
    e.closest('.card-wrapper') ||
    e.parentElement.parentElement.parentElement.parentElement.parentElement;
  var mediaLink = cardRoot.querySelector('.card__media a');
  var imgs = mediaLink ? mediaLink.querySelectorAll('img.featured_image') : [];
  var featuredImgURL = cardProductResolveImgUrl(e.dataset.featuredImg);
  var secondImgURL = cardProductResolveImgUrl(e.dataset.secondImg);
  var numDiscount = e.dataset.discount;
  var discountEle = cardRoot.getElementsByClassName('badge-discount');

  if (imgs[0] && featuredImgURL) {
    imgs[0].src = featuredImgURL;
    imgs[0].srcset = featuredImgURL + ' 1066w';
  }
  var mediaHover = cardRoot.querySelector('.card__media .media.media--hover-effect');
  if (imgs[1]) {
    if (secondImgURL) {
      imgs[1].src = secondImgURL;
      imgs[1].srcset = secondImgURL + ' 1066w';
      imgs[1].removeAttribute('hidden');
      imgs[1].style.display = '';
      if (mediaHover) mediaHover.classList.remove('media--variant-no-secondary');
    } else {
      imgs[1].removeAttribute('src');
      imgs[1].removeAttribute('srcset');
      imgs[1].style.display = 'none';
      if (mediaHover) mediaHover.classList.add('media--variant-no-secondary');
    }
  } else if (mediaHover) {
    mediaHover.classList.add('media--variant-no-secondary');
  }

  for (let x = 0; x <= discountEle.length; x++) {
    if (discountEle[x] != undefined) {
      if (numDiscount != '') {
        discountEle[x].innerHTML = numDiscount + '% OFF';
        discountEle[x].style.display = 'block';
      } else {
        discountEle[x].style.display = 'none';
      }
    }
  }

  if (e.dataset.price) {
    let priceWrapper = cardRoot.querySelector('.price');
    let priceContainer = cardRoot.querySelector('.price__container');
    if (priceWrapper && priceContainer) {
      let hasCompare = e.dataset.hasCompare === 'true';
      let compareAtPrice = e.dataset.compareAtPrice;
      let currentPrice = e.dataset.price;
      let existingDiv = priceContainer.querySelector('.price__sale') || priceContainer.querySelector('.price__regular');
      if (existingDiv) {
        if (hasCompare && compareAtPrice) {
          priceWrapper.classList.add('price--on-sale');
          let saleDiv = document.createElement('div');
          saleDiv.className = 'price__sale';
          saleDiv.innerHTML =
            '<span class="visually-hidden visually-hidden--inline">Precio regular</span>' +
            '<span><s class="price-item price-item--regular">' + compareAtPrice + '</s></span>' +
            '<span class="visually-hidden visually-hidden--inline">Precio de oferta</span>' +
            '<span class="price-item price-item--sale price-item--last price-item--sale-with-compare">' + currentPrice + '</span>';
          existingDiv.replaceWith(saleDiv);
        } else {
          priceWrapper.classList.remove('price--on-sale');
          let regularDiv = document.createElement('div');
          regularDiv.className = 'price__regular';
          regularDiv.innerHTML =
            '<span class="visually-hidden visually-hidden--inline">Precio regular</span>' +
            '<span class="price-item price-item--regular">' + currentPrice + '</span>';
          existingDiv.replaceWith(regularDiv);
        }
      }
    }
  }
}

function validateVariantSelected(e, id) {
  if (e.classList.contains('available-false')) {
    return;
  }

  var quick_add_parent =
    e.closest('.card-wrapper') ||
    e.parentElement.parentElement.parentElement.parentElement.parentElement;

  var elements = quick_add_parent.getElementsByClassName('product-variant-id');

  var newSpanContainer = quick_add_parent;
  let badgeDiscount = newSpanContainer.querySelector('.badge-discount');
  if (badgeDiscount) {
    if (e.dataset.discount) {
      badgeDiscount.innerText = e.dataset.discount + '% OFF';
      badgeDiscount.classList.add('active');
    } else {
      badgeDiscount.classList.remove('active');
    }
  }

  for (let x = 0; x <= elements.length; x++) {
    if (elements[x] != undefined) {
      elements[x].value = id;
    }
  }

  let childrenList = e.parentElement.children;
  for (let x = 0; x <= childrenList.length; x++) {
    if (childrenList[x] != undefined) {
      childrenList[x].classList.remove('active');
    }
  }
  e.classList.add('active');
  updateImages(e);

  var badgesContainer = quick_add_parent.querySelector('[data-card-badges]');
  var badgesJson = quick_add_parent.querySelector('.card-variant-badges-json');
  if (badgesContainer && badgesJson) {
    try {
      var badgeMap = JSON.parse(badgesJson.textContent);
      if (badgeMap[id]) {
        badgesContainer.innerHTML = badgeMap[id];
      }
    } catch (err) {
      /* no-op */
    }
  }
}
